export const i18nRequiredKeyword = {
  keyword: "i18nRequired",
  type: "object",
  schemaType: "boolean",
  error: {
    message: "this field is required",
  },
  validate: function (schema, data) {
    if (!schema) return true;
    if (typeof data !== "object" || data === null) return false;

    const values = Object.values(data);
    if (values.length === 0) return false;

    return values.some(
      (value) => typeof value === "string" && value.trim().length > 0
    );
  },
};

export function registerI18nKeywords(ajv) {
  ajv.addKeyword(i18nRequiredKeyword);
  return ajv;
}
